import axios from "axios";

//
// Function for registering new user
//

export const register = (newUser) => {
    return axios
        .post("/api/user/register", newUser)
        .then((response) => {
            console.log("Registered");
            console.log(response);
            return response;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Something Went Wrong, Please Try Again!!.",
                        },
                    },
                });
            }
        });
};

//
// Function for updating user information
//

export const updateUser = (userInfo, id) => {
    let url = "/api/user/" + id;
    return axios
        .put(url, userInfo)
        .then((response) => {
            console.log("Updated");
            console.log(response);
            return response;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Something Went Wrong, Please Try Again!!.",
                        },
                    },
                });
            }
        });
};

//
// Function for delete user
//

export const deleteUser = (id) => {
    let url = "/api/user/" + id;
    return axios
        .delete(url)
        .then((response) => {
            console.log("Updated");
            console.log(response);
            return response;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Something Went Wrong, Please Try Again!!.",
                        },
                    },
                });
            }
        });
};

export const downloadOTP = (id) => {
    let url = "/api/user/download-otp/" + id;
    return axios
        .get(url)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Something Went Wrong, Please Try Again!!.",
                        },
                    },
                });
            }
        });
};

export const resetUserCredentials = (id) => {
    let url = "/api/user/reset-otp/" + id;
    return axios
        .post(url)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Something Went Wrong, Please Try Again!!.",
                        },
                    },
                });
            }
        });
};

//
// Function to download close loop xosc files
//
export const downloadXoscCloseLoop = (payload, destination_url) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in downloading XOSC file",
                        },
                    },
                });
            }
        });
};

//
// Function to get the landing page(Home Page)
//

export const getLandingPage = (destination_url) => {
    return axios
        .post(destination_url)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};

//
// Function to authorize login
//

export const login = (user) => {
    return axios
        .post("users/login", {
            email: user.email,
            password: user.password,
        })
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};

//
// Function to get profile details
//

export const getProfile = () => {
    return axios
        .get("users/profile", {
            //headers: { Authorization: ` ${this.getToken()}` }
        })
        .then((response) => {
            console.log(response);
            return response.data;
        })
        .catch((err) => {
            console.log(err);
        });
};

//
// Function to get the bench mapping data information
//

export const getTestDataBenchMappingInfo = () => {
    return axios
        .post("get_sensor_bench_mapping")
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

//
// Function to test the bench info for close loop
//

export const getTestDataBenchMappingInfoCloseLoop = () => {
    return axios
        .post("get_sensor_bench_mapping_close_loop")
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

//
// Function to get scenario group details
//

export const getScenarioGroupInfo = (page = 1) => {
    return axios
        .post(`get_scenario_grouping?page=${page}`)
        .then((response) => {
            console.log(response);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

//
// Function to get sceario group details for close loop
//

export const getScenarioGroupInfoCloseLoop = (page = 1) => {
    return axios
        .post(`get_scenario_grouping_close_loop?page=${page}`)
        .then((response) => {
            console.log(response);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

//
// Function to get scenario group instance details for close loop
//

export const getScenarioGroupInfoCloseLoopInstanceDetail = (page = 1,dataToSend) => {
    return axios
        .post(`get_scenario_groups_close_loop_instance_details?page=${page}`,dataToSend)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in fetching pagination info",
                        },
                    },
                });
            }
        });
};

export const cmGetScenarioGroupInfoCloseLoopInstanceDetail = (page = 1,dataToSend) => {
    return axios
        .post(`get_cm_scenario_groups_close_loop_instance_details?page=${page}`,dataToSend)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in fetching pagination info",
                        },
                    },
                });
            }
        });
};

//
// Function to get variation list details for scenario group selected
//

export const fetchVariationListForGroup = (scenarioId, page = 1) => {
    console.log("yes its")
    console.log("yes its", scenarioId)
    return axios
        .post(`get_scenario_details_from_scenario_groups?page=${page}&scenarioId=${scenarioId}`)
        .then((response) => {
            console.log("get_scenario_details_from_scenario_groups",response);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in fetching pagination info",
                        },
                    },
                });
            }
        });
};


export const cmFetchVariationListForGroup = (scenarioId, page = 1) => {
    console.log("yes its")
    console.log("yes its", scenarioId)
    return axios
        .post(`cm_get_scenario_details_from_scenario_groups?page=${page}&scenarioId=${scenarioId}`)
        .then((response) => {
            console.log("get_scenario_details_from_scenario_groups",response);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in fetching pagination info",
                        },
                    },
                });
            }
        });
};
//
// Function to edit scenario group instance details for close loop
//

export const editScenarioGroupCloseLoopInstanceDetail = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in updating scenario group instance details",
                        },
                    },
                });
            }
        });
};

export const cmEditScenarioGroupCloseLoopInstanceDetail = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in updating scenario group instance details",
                        },
                    },
                });
            }
        });
};

//
// Function to get scenario group list details for close loop
//

export const selectAllScenarioGroups = (payload) => {

    return axios
        .post(`fetch_all_scenario_groups_list`,payload)
        .then((response) => {
            // console.log(response);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in fetching pagination info",
                        },
                    },
                });
            }
        });
};
export const cmSelectAllScenarioGroups = (payload) => {

    return axios
        .post(`cm_fetch_all_scenario_groups_list`,payload)
        .then((response) => {
            // console.log(response);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in fetching pagination info",
                        },
                    },
                });
            }
        });
};

//
// Function to get scenario group progress
//

export const getScenarioGroupProgress = (destination_url) => {
    return axios
        .post(destination_url)
        .then((response) => {
            console.log(response);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

//
// Function to stop scenario group process
//

export const stopScenarioGroupingProcess = (destination_url) => {
    return axios
        .post(destination_url)
        .then((response) => {
            console.log(response);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

//
// Function to get scenario drive session details from database
//

export const getDatabaseDetails = () => {
    return axios
        .post("get_scenario_drive_session_mapping")
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

//
// Function to update scenario group details
//

export const updateScenarioGroupDetails = (payload) => {
    return axios
        .post("update_scenario_group", payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};

//
// Function to send data to bench
//
export const sendToBench = (payload, destination_url) => {
    console.log("payload : ", payload);
    console.log("url : ", destination_url);
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};

//
// Function to pull data from bench
//
export const pullFromBench = (payload, destination_url) => {
    console.log("payload for pulling : ", payload);
    console.log("url for pulling : ", destination_url);
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};

//
// Function to send close loop data to bench
//

export const sendToBenchCloseLoop = (payload, destination_url) => {
    console.log("payload : ", payload);
    console.log("url : ", destination_url);
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};

//
// Function to pull close loop data from bench
//
export const pullFromBenchCloseLoop = (payload, destination_url) => {
    console.log("payload for populling : ", payload);
    console.log("url for pulling : ", destination_url);
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};

//
// Function to get scenario catalogue from mysql database
//
export const getScenarioCatalogueInfo = (page = 1) => {
    return axios
        .post(`fetch_scenario_catalogue_data_from_mysql?page=${page}`)
        .then((response) => {
            console.log(response);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

//
// Function to clean input and output bench details
//

export const cleanBenchInputOutput = (destination_url, payload) => {
    console.log("cleaning bench input and output");
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};

//
// Function to clean input and output bench details for close loop
//
export const cleanBenchInputOutputClosedLoop = (destination_url, payload) => {
    console.log("cleaning bench input and output");
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};

//
// Function to start bench process
//
export const startBenchProcess = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};

//
// Function to stop bench process
//
export const stopBenchProcess = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};

//
// Function to edit the database
//
export const editDb = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to delete the database
//
export const deleteDb = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error while deleting scenario group",
                        },
                    },
                });
            }
        });
};

//
// Function to get the validation metrics details
//

export const getValidationMetrics = (payload) => {
    return axios
        .post("get_validation_metrics", payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};

//
// Function to get the validation metrics details for level 2
//
export const getValidationMetrics_lvl2 = (payload) => {
    return axios
        .post("get_validation_metrics_lvl2", payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to get the validation class
//
export const getValidationClass = (payload) => {
    return axios
        .post("get_validation_class", payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to get the level 2 validation class
//
export const getValidationClass_lvl2 = (payload) => {
    return axios
        .post("get_validation_class_lvl2", payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to get validation table
//
export const getValidationTable = (payload) => {
    return axios
        .post("get_validation_table", payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to get level 2 validation table
//
export const getValidationTable_lvl2 = (payload) => {
    return axios
        .post("get_validation_table_lvl2", payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to get the images file path
//
export const getImagesFilePath = (payload) => {
    return axios
        .post("get_images_file_path", payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to get the id values
//
export const getIdValues = (payload) => {
    return axios
        .post("get_dropdown_ids", payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to get level 2 id values
//
export const getIdValuesLvl2 = (payload) => {
    return axios
        .post("get_dropdown_ids_lvl2", payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to get advance search results
//

export const getAdvanceSearchResults = (payload) => {
    return axios
        .post("get_advance_search_results", payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to get class names
//
export const getClassNames = (payload) => {
    return axios
        .post("get_class_names", payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to add scenario
//
export const addScenario = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to add scenario in close loop
//
export const addScenarioCloseLoop = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in adding scenario to group",
                        },
                    },
                });
            }
        });
};

//
// Function to add scenario groups in CAD
//
export const addScenarioGropsCAD = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in adding scenario groups to cad topology",
                        },
                    },
                });
            }
        });
};
//
// Function to get test run status information
//
export const getTestRunStatusInfo = (page = 1) => {
    return axios
        .post(`fetch_test_run_status_from_mysql?page=${page}`)
        .then((response) => {
            console.log(response);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to get test run information of close loop
//
export const getTestRunStatusInfoCloseLoop = (page = 1) => {
    return axios
        .post(`fetch_test_run_status_from_mysql_close_loop?page=${page}`)
        .then((response) => {
            console.log(response);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const getNewTestRunStatusInfoCloseLoop = (page = 1, payload) => {
    return axios
        .post(`fetch_new_test_run_status_from_mongo_close_loop?page=${page}`, payload)
        .then((response) => {
            console.log(response);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to get summary of total scenario groups
//
export const getTotalScenarioGroupsSummary = () => {
    return axios
        .post("/get_total_scenario_groups_summary")
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to update bench status table
//
export const updateBenchStatusTable = (payload, destination_url) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to update bench status table of close loop
//
export const updateBenchStatusTableClosedLoop = (payload, destination_url) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to add test point
//
export const addTestPoint = (payload, destination_url) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to add test point for close loop
//
export const addTestPointCloseLoop = (payload, destination_url) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};

//
// Function to edit test point
//
export const editTestPoint = (payload, destination_url) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to remove test point
//
export const removeTestPoint = (payload, destination_url) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to remove test point in close loop
//
export const removeTestPointClosedLoop = (payload, destination_url) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to get bench details
//
export const getBenchDetails = (destination_url) => {
    return axios
        .post(destination_url)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to get bench details of close loop
//
export const getBenchDetailsCloseLoop = (destination_url) => {
    return axios
        .post(destination_url)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to get all scenario group names
//
export const getAllScenarioGroupNames = (destination_url) => {
    return axios
        .post(destination_url)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to get all scenario group names of close loop
//
export const getAllScenarioGroupNamesCloseLoop = (destination_url) => {
    return axios
        .post(destination_url)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to create bench data
//
export const createBenchData = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to create bench data for close loop
//
export const createBenchDataCloseLoop = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Scenario Catalogue Migration
//Function to get welcome page data
//
export const getWelcomePageData = () => {
    return axios
        .post("get_welcome_page_data")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to get dashboard page data
//
export const getDashboardPageData = () => {
    return axios
        .post("get_dashboard_page_data")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to get scenario catalogue value for listing
//
export const getScenarioCatalogueValueForListing = (page = 1, queryValue = null) => {
    return axios
        .post(
            `${window.location.origin}/get_scenario_catalogue_value_for_listing/?page=${page}&query_data=${queryValue}`
        )
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

//
// Function to get scenario collection value for listing
//
export const getScenarioCollectionForListing = (page = 1) => {
    return axios
        .post(`${window.location.origin}/view_master_base_scenario_collection?page=${page}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

//
// Function to get the tab data
//
export const getDataTab = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};

//
// Function to upload carla scenario
//

export const uploadCarlaScenario = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};

//
// Function to get all scenarios of close loop
//
export const getAllScenarioCloseLoop = (page = 1) => {
    return axios
        .post(`close_loop_fetch_all_scenario?page=${page}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return Promise.reject(error);
        });
};

export const getAllCustomMapsCloseLoop = (page = 1) => {
    return axios
        .post(`/close_loop/fetch/custom_map_details?page=${page}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const getAllAdClientsCloseLoop = (page = 1) => {
    return axios
        .post(`/close_loop/fetch/ad_client_details?page=${page}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

//automate kpi migration

//automate kpi tja v1 migration

//
// Function to get scenario data for tja v1
//

export const getScenarioDataTjaV1 = () => {
    return axios
        .post("/get_tja_v1_system_and_statistics")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to get system and other statistics of tja v1
//
export const getSystemAndOtherStatisticsTjaV1 = () => {
    return axios
        .post("/get_tja_v1_system_and_statistics")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to get kpi summary dashboard data for tja v1
//
export const getKpiSummaryDashboardTjaV1 = () => {
    return axios
        .post("/get_tja_v1_kpi_summary_dashboard")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to get kpi detailed dashboard details for tja v1
//
export const getKpiDetailedDashboardTjaV1 = () => {
    return axios
        .post("/get_tja_v1_kpi_detailed_dashboard")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to get selected scenario details for tja v1
//
export const getSelectedScenarioDetailsTjaV1 = (scenario_id) => {
    return axios
        .post("/get_tja_v1_selected_scenario_details", {
            scenario_id,
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};

//automate kpi tja v2 migration
//
// Function to get scenario data for tja v2
//

export const getScenarioDataTjaV2 = () => {
    return axios
        .post("/get_tja_v2_system_and_statistics")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to get system and other statistics of tja v2
//
export const getSystemAndOtherStatisticsTjaV2 = () => {
    return axios
        .post("/get_tja_v2_system_and_statistics")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to get kpi summary dashboard data for tja v2
//
export const getKpiSummaryDashboardTjaV2 = () => {
    return axios
        .post("/get_tja_v2_kpi_summary_dashboard")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to get kpi summary details for kpi summary dashboard version2
//
export const getTopologyName = () => {
    return axios
        .post("/get_topology_name")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in fetching topology data",
                        },
                    },
                });
            }
        });
};
// Function to get kpi summary details for kpi summary dashboard version2
//
export const getScenarioGroupDetailForTopology = (payload) => {
    return axios
        .post("/get_scenario_group_detail_for_topology", payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};

//
// Optimised Function to get good and not good scenario details for kpi summary dashboard enhanced
//
export const getBaseScenarioAndVariationCountForExecution = (destination_url) => {
    return axios
        .get(destination_url)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to get kpi detailed dashboard details for tja v2
//
export const getKpiDetailedDashboardTjaV2 = () => {
    return axios
        .post("/get_tja_v2_kpi_detailed_dashboard")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to get selected scenario details for tja v2
//
export const getTjaSelectedCsvDataTjaV2 = (payload) => {
    return axios
        .post("/get_tja_v2_selected_csv_data", payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};

//
// Function to failed kpi report
//
export const getFailedKpiReport = (payload) => {
    return axios
        .post("/find_kpi_fail_case_updated", payload, {responseType: "blob"})
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in downloading XOSC file",
                        },
                    },
                });
            }
        });
};

//
// Function to get cad topology uuids
//
export const getCadTopologyUuids = () => {
    return axios
        .post("/get_cad_topology_uuids")
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in downloading XOSC file",
                        },
                    },
                });
            }
        });
};
//
// Function to get tja id values for tja v2
//
export const getTjaIdValuesTjaV2 = () => {
    return axios
        .post("/get_tja_v2_level3_dropdown_ids")
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to scene id values for TJA v2
//
export const getTjaIdValuesTjaV2FromMongo = () => {
    return axios
        .post("/get_tja_v2_level3_dropdown_ids_frm_mongo")
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};

export const getSceneIdValuesTjaV2 = (payload) => {
    return axios
        .post("/get_tja_v2_popup_scene_ids", payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to get filter optons
//
export const getSceneIdValuesTjaV2FromMongo = (payload) => {
    return axios
        .post("/get_tja_v2_popup_scene_ids_from_mongo", payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};

export const getFilterOptions = () => {
    return axios
        .post("/get_filter_options")
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to send detals for downloading the file
//
export const sendDetailsToDownloadFile = (payload) => {
    return axios
        .post("/download_xosc", payload, { responseType: "blob" })
        .then((response) => response)
        .catch((error) => {
            console.log(error);
        });
};

//
// Function to get Valid Scenario Listing Data
//
export const getValidScenarioListingData = (page = 1) => {
    return axios
        .post(`/get_valid_scene_data_for_listing/?page=${page}`)
        .then((response) => response.data)
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to start Bench Closed Loop Process
//
export const startBenchClosedLoopProcess = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to stop Bench Closed Loop Process
//
export const stopBenchClosedLoopProcess = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            console.log(err);
        });
};
//
// Function to update Custom Value
//
export const updateCustomValue = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to check Permission
//
export const checkPermission = (token) => {
    return axios
        .post(
            "/check_permission",
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to send Config Data To Database
//
export const sendConfigDataToDatabase = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to download report files
//
export const downloadReportFiles = (destination_url, payload) => {
    return axios
        .post(destination_url, payload, { responseType: "blob" })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in downloading report file",
                        },
                    },
                });
            }
        });
};
//
// Function to download report files
//
export const downloadCADTopology = (destination_url, payload) => {
    return axios
        .post(destination_url, payload, { responseType: "json" })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in downloading cad topology file",
                        },
                    },
                });
            }
        });
};
//
// Function to download Log files
//
export const downloadLogFiles = (destination_url, payload) => {
    return axios
        .post(destination_url, payload, { responseType: "blob" })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in downloading log file",
                        },
                    },
                });
            }
        });
};
//
// Function to update Config Data To Database
//
export const updateConfigDataToDatabase = (destination_url, payload) => {
    return axios
        .put(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to Read CAD Cloud Topology
//

export const ReadCADCloudTopology = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to delete Config Data From Database
//
export const deleteConfigDataFromDatabase = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to save Uploaded Cad Topology
//
export const saveUploadedCadTopology = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to get Data From Database For CadTopology
//
export const getDataFromDatabaseForCadTopology = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};

//
// Function to set  user_id in TicketIDManagement db
//
export const setUserIdInDb = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to initiate Download Report Process
//

export const initiateDownloadReportProcess = (payload) => {
    return axios
        .post("/close_loop/download_evaluation_report", payload)
        .then((response) => response)
        .catch((error) => {
            console.log(error);
        });
};
//
// Function to reset All Queues From AWS For CadTopology
//

export const resetAllQueuesFromAWSForCadTopology = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error while resetting queues",
                        },
                    },
                });
            }
        });
};

// Fetch KPI Threshold Values Request
export const fetchKPIThreshold = () => {
    return axios
        .get("/close_loop/analytics/fetch_kpi_thresholds/")
        .then((response) => response)
        .catch((error) => console.log(error));
};

// Re-evaluate Scenario Request
export const reevaluateScenario = (payload) => {
    return axios
        .put("/close_loop/analytics/re-evaluate_scenario_data/", payload)
        .then((response) => response)
        .catch((error) => console.log(error));
};

// To Fetch filter data Request
export const getFilterDataForReport = () => {
    return axios
        .get("/close_loop/performance_report/filter_data/")
        .then((response) => {
            return response;
        })
        .catch((error) => console.log(error));
};

// To fetch all execution dates
export const getDatesForArtifacts = () => {
    return axios
        .get("/fetch_all_execution_dates")
        .then((response) => {
            return response;
        })
        .catch((error) => console.log(error));
};

// To fetch all ticket ids
export const getTicketIdsForArtifacts = () => {
    return axios
        .get("/fetch_all_ticket_id")
        .then((response) => {
            return response;
        })
        .catch((error) => console.log(error));
};

// To fetch all execution AD Version
export const getADVersionForArtifacts = () => {
    return axios
        .get("/fetch_all_ad_versions")
        .then((response) => {
            return response;
        })
        .catch((error) => console.log(error));
};

// To fetch all execution AD Version
export const getADVersionForExecution = () => {
    return axios
        .get("/fetch_all_ad_versions_for_execution")
        .then((response) => {
            return response;
        })
        .catch((error) => console.log(error));
};

// To fetch all data as per artifacts
export const getArtifactDetails = (payload) => {
    return axios
        .post("/fetch_artifacts_by_multioptions ", payload)
        .then((response) => {
            return response;
        })
        .catch((error) => console.log(error));
};

// To update ad version
export const updateAdForExecution = (payload) => {
    return axios
        .post("/update_ad_version ", payload)
        .then((response) => {
            return response;
        })
        .catch((error) => console.log(error));
};

// To fetch execution report details request
export const getExecutionReportDetails = (payload) => {
    return axios
        .post("/close_loop/performance_report/execution_report_details/", payload)
        .then((response) => response)
        .catch((error) => console.log(error));
};

// To fetch system performance chart details request
export const getSystemPerformanceData = (payload) => {
    return axios
        .post("/close_loop/performance_report/system_performance/", payload)
        .then((response) => response)
        .catch((error) => console.log(error));
};

// To fetch system performance chart details request
export const getSystemPerformanceDataCSV = (payload) => {
    return axios
        .post("/close_loop/performance_report/system_performance_data/", payload, {
            responseType: "blob",
        })
        .then((response) => response)
        .catch((error) => console.log(error));
};

export const getScenarioDataTestRunStatusTable = (payload) => {
    return axios
        .post("/get_scene_data_test_run_status_table", payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
export const GetAwsQueuesFromConfig = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Error in fetch queues from config",
                        },
                    },
                });
            }
        });
};

// to fetch CAD Topology tag names request
export const getCADTopologyTagNames = () => {
    return axios
        .get("/close_loop/cad_topology/tag_names/")
        .then((response) => response)
        .catch((error) => {
            console.log(error);
        });
};
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

// to fetch test runs using cad topology uuid
export const getTestRunsFromTagName = (payload) => {
    return axios
        .post("/close_loop/cad_topology/test_runs_from_tag_name/", payload)
        .then((response) => response)
        .catch((error) => {
            console.log(error);
        });
};

// to fetch test runs status for cad topology using uuid
export const getTestRunStatusForCADTopology = (payload) => {
    return axios
        .post("/get_test_results_cad", payload)
        .then((response) => response)
        .catch((error) => {
            console.log(error);
        });
};

// To kill and terminate all instances
export const killAndTerminateAllInstances = (destination_url) => {
    return axios
        .post(destination_url)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            // if (
            //     error.hasOwnProperty("response") &&
            //     error.response.hasOwnProperty("data") &&
            //     error.response.data.hasOwnProperty("message")
            // ) {
            if (
                Object.prototype.hasOwnProperty.call(error, "response") &&
                Object.prototype.hasOwnProperty.call(error.response, "data") &&
                Object.prototype.hasOwnProperty.call(error.response.data, "message")
            ) {
                return Promise.reject(error);
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: "Something Went Wrong, Please Try Again!!.",
                        },
                    },
                });
            }
        });
};

export const get_apm_data_from_mongo = (destination_url) => {
    return axios
        .post(destination_url)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const get_apm_dashboard_details = (destination_url) => {
    return axios
        .post(destination_url)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const getNewScenarioViewInfoCloseLoop = (payload) => {
    return axios
        .post(`filter_scenario_view_close_loop`, payload)
        .then((response) => {
            console.log(response);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const getCurrentScenarioRunningDetails = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};
export const variationGeneration = (destination_url) => {
    return axios
        .post(destination_url)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const scenarioVariationGeneration = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const uploadBulkScenarioFilesProgress = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const cleanData = (destination_url) => {
    return axios
        .post(destination_url)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const cleanBulkScenarioInputData = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const killAndTerminateSelectedInstance = (destination_url, payload) => {
    return axios
        .post(destination_url, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
};

export const IndividualScenarioKPIEvaluation = (destination_url) => {
    return (
        axios
            // .get('/get/individual/scenario/all/kpi_status')
            .get(destination_url)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log(error);
            })
    );
};